import React, { useContext, useEffect, useState } from 'react';
import { Accounts_Selected_Set } from '../../Contexts/Context_AccountManagement_SelectedAccount';
import _ from 'lodash';
import { Accounts_Delete, Accounts_GetByID, Accounts_Update } from '../../api/API_Accounts';
import { useAuth } from '../../Contexts/AuthContext';
import { useAccountsListRefresh } from '../../Contexts/Context_AccountManagement_RefreshList';
import { Context_UI, UI_Refresh } from '../../Contexts/Context_UI';
import { useStatus } from '../../Contexts/Context_Status_Global';
import { useTemplating } from '../../Contexts/Context_Templating';
import { useAccounts } from '../../Contexts/Context_Accounts';
import UI_Dropdown from '../ERUMAUI/UI_Dropdown';
import UI_Radio from '../ERUMAUI/UI_Radio';
// import { Accounts_Selected_Set } from '../Contexts/Context_AccountManagement_SelectedAccount';


export default function Panel_AccountManagement_Right() {
    const UI = useContext(Context_UI);
    const { Accounts_Refresh_Indicator, List_Refresh } = useAccountsListRefresh();
    const { Account, Loading } = useAuth();
    const { Template_List } = useTemplating();
    const { Status_Saving_Set, List_Unsaved, List_Unsaved_Set } = useStatus();
    const [Radio_Role, Radio_Role_Set] = useState("AM_Role_Custom");
    // const { Accounts_Selected, Change_InProgress, Change_InProgress_Set } = Accounts_Selected_Set();
    
    // const [ Commit_Loading, Commit_Loading_Set ] = Accounts_Selected_Set();
    const {
        Accounts_List,
        Accounts_Selected,
        Accounts_ChangeInProgress,
        Account_Fetch_ByID,
        Account_Update,
        Accounts_Refresh,
        Accounts_Mode,
        Accounts_Mode_Set,
        Pattern_Administrator,
        Pattern_Teacher,
        Pattern_Staff,
        Pattern_Staff_GSU,
        Pattern_Guard,
        Pattern_Empty,
        Account_Approve,
        Account_Reject,
        Account_Reinstate,
        Account_Deactivate,
        Account_Reactivate
    } = useAccounts();
    const [WorkingData, WorkingData_Set] = useState(null);
    const [Attempt_Loading, Attempt_Loading_Set] = useState(false);
    const [WorkingData_Changed, WorkingData_Changed_Set] = useState(false);

    useEffect(() => {
        if (!Accounts_Selected) {
            WorkingData_Set(null);
            WorkingData_Changed_Set(null);
            return;
        }
        WorkingData_Set(_.cloneDeep(Accounts_Selected));
        WorkingData_Changed_Set(false);
        Status_Saving_Set("None");
    }, [Accounts_Selected, Status_Saving_Set])

    useEffect(() => {
        if (WorkingData_Changed) {
            if (!List_Unsaved.includes("Permission Management")) {
                List_Unsaved_Set(prev => [...prev, "Permission Management"]);
            }
        } else {
            if (List_Unsaved.includes("Permission Management")) {
                List_Unsaved_Set(prev => prev.filter(Item => Item !== "Permission Management"));
            }
        }
    }, [WorkingData_Changed])

    useEffect(() => {
        if (Accounts_Selected && Accounts_Selected?.Approval?.State == "Pending" && Accounts_Mode == "Approve") {
            Account_Approve();
        }
        if (Accounts_Selected && Accounts_Selected?.Approval?.State == "Pending" && Accounts_Mode == "Reject") {
            setTimeout(() => {
                document.getElementById("Reason_AccountDenial").querySelector(".Dropdown_Button").click();
            }, 100);
        }
        if (Accounts_Selected && Accounts_Selected?.Approval?.State == "Approved" && Accounts_Mode == "Edit") {
            setTimeout(() => {
                document.getElementById("AM_Role_Teacher").focus();
            }, 100);
        }
        if (Accounts_Selected && Accounts_Selected?.Approval?.State == "Approved" && Accounts_Mode == "Deactivate") {
            Account_Deactivate();
        }
        if (Accounts_Selected && Accounts_Selected?.Approval?.State == "Deactivated" && Accounts_Mode == "Reactivate") {
            Account_Reactivate();
        }
        if (Accounts_Selected && Accounts_Selected?.Approval?.State == "Rejected" && Accounts_Mode == "Reactivate") {
            Account_Reinstate();
        }
        if (Accounts_Selected && Accounts_Selected?.Approval?.State == "Rejected" && Accounts_Mode == "Delete") {
            Account_Delete();
        }
    }, [Accounts_Mode, Accounts_Selected])

    useEffect(() => {
        if (!WorkingData) { return; }
        Permission_WorkingData_Set();
        Permission_CheckPattern({ Access: WorkingData?.Access });
    }, [WorkingData]);

    if (!Accounts_Selected) {
        return <p className='General_Paragraph'>
            Please select an account from the list.
        </p>;
    }

    if (Loading) {
        return null;
    }

    const WorkingData_Local_Update = (Updater) => {
        WorkingData_Set(prev => {
            const Next = _.cloneDeep(prev || {});
            Updater(Next);
            return Next;
        });
        WorkingData_Changed_Set(true);
    }

    const Toggle_Click = (e) => {
        window.Buttons_Toggle(e.currentTarget.id);
        Permission_WorkingData_Update();
        Permission_CheckPattern(WorkingData);
        WorkingData_Changed_Set(true);
    }
    const Radio_Click = (e) => {
        // UI.Radio_Select(e.currentTarget.id, "Radio_AM_PermissionList");
        Permission_Pattern_Set(UI.Element_Attribute_Get("Radio_AM_PermissionList", "Radio_ActiveButton"));
        WorkingData_Changed_Set(true);
    }

    const Permission_Pattern_Set = (Role) => {
        let Pattern = null;
        if (Role === "AM_Role_Teacher") {
            Pattern = Pattern_Teacher;
        } else if (Role === "AM_Role_Staff") {
            Pattern = Pattern_Staff;
        } else if (Role === "AM_Role_Staff_GSU") {
            Pattern = Pattern_Staff_GSU;
        } else if (Role === "AM_Role_Guard") {
            Pattern = Pattern_Guard;
        } else if (Role === "AM_Role_Administrator") {
            Pattern = Pattern_Administrator;
        } else if (Role === "AM_Role_Custom") {
            Pattern = Pattern_Empty;
        }
        if (Pattern) {
            WorkingData_Local_Update(Next => {
                Next.Access = _.cloneDeep(Pattern);
            });
            Permission_WorkingData_Set();
        }
    }

    const Permission_CheckPattern = (Data) => {
        if (!WorkingData || !Data) { return; }
        if (WorkingData?.Approval?.State === "Approved" && WorkingData?.isSystemAdmin !== true) {
            if (_.isEqual(Data.Access, Pattern_Teacher)) {
                // UI.Radio_Select("AM_Role_Teacher");
                Radio_Role_Set("AM_Role_Teacher");
            } else if (_.isEqual(Data.Access, Pattern_Staff)) {
                // UI.Radio_Select("AM_Role_Staff");
                Radio_Role_Set("AM_Role_Staff");
            } else if (_.isEqual(Data.Access, Pattern_Staff_GSU)) {
                // UI.Radio_Select("AM_Role_Staff");
                Radio_Role_Set("AM_Role_Staff_GSU");
            } else if (_.isEqual(Data.Access, Pattern_Guard)) {
                // UI.Radio_Select("AM_Role_Staff");
                Radio_Role_Set("AM_Role_Guard");
            } else if (_.isEqual(Data.Access, Pattern_Administrator)) {
                // UI.Radio_Select("AM_Role_Administrator");
                Radio_Role_Set("AM_Role_Administrator");
            } else {
                // UI.Radio_Select("AM_Role_Custom");
                Radio_Role_Set("AM_Role_Custom");
            }
        }

    }

    

    

    const Permission_WorkingData_Update = () => {
        WorkingData_Local_Update(
            Next => {
                Next.Access = {
                    InteractiveMap: {
                        View: Permission_ToggleState_Get("Permission_InteractiveMap_View"),
                        Edit: Permission_ToggleState_Get("Permission_InteractiveMap_Edit")
                    },
                    Schedules: {
                        View: Permission_ToggleState_Get("Permission_Schedules_View")
                    },
                    Reservation: {
                        Create: Permission_ToggleState_Get("Permission_Reservation_Create"),
                        Edit: Permission_ToggleState_Get("Permission_Reservation_Edit"),
                        Overwrite: false,
                        Approve: {
                            Initial: Permission_ToggleState_Get("Permission_Reservation_Approve_Initial"),
                            Final: Permission_ToggleState_Get("Permission_Reservation_Approve_Final")
                        },
                        Delegateable: Permission_ToggleState_Get("Permission_Reservation_Delegateable")
                    },
                    Report: {
                        View: Permission_ToggleState_Get("Permission_Report_View"),
                        ScheduleTimetable: Permission_ToggleState_Get("Permission_Report_ScheduleTimetable"),
                        RoomUtilization: Permission_ToggleState_Get("Permission_Report_RoomUtilization"),
                        MapOverview: Permission_ToggleState_Get("Permission_Report_MapOverview"),
                        ReservationSlip: Permission_ToggleState_Get("Permission_Report_ReservationSlip"),
                        AccountList: Permission_ToggleState_Get("Permission_Report_AccountList"),
                        ActivityLog: Permission_ToggleState_Get("Permission_Report_ActivityLog")
                    },
                    Account: {
                        Manage_Self: Permission_ToggleState_Get("Permission_Account_Manage_Self"),
                        Manage_Others: Permission_ToggleState_Get("Permission_Account_Manage_Others")
                    },
                    Templating: {
                        View: Permission_ToggleState_Get("Permission_Templating_View"),
                        Edit: Permission_ToggleState_Get("Permission_Templating_Edit")
                    }
                }
            }
        );
    }

    const Permission_WorkingData_Set = () => {
        if (!WorkingData || !WorkingData?.Approval) { return; }
        try {
            if (WorkingData?.Approval?.State === "Approved" && WorkingData?.isSystemAdmin !== true) {
                Permission_ToggleState_Set("Permission_InteractiveMap_View", WorkingData?.Access.InteractiveMap.View);
                Permission_ToggleState_Set("Permission_InteractiveMap_Edit", WorkingData?.Access.InteractiveMap.Edit);

                Permission_ToggleState_Set("Permission_Schedules_View", WorkingData?.Access.Schedules.View);
                Permission_ToggleState_Set("Permission_Reservation_Create", WorkingData?.Access.Reservation.Create);
                Permission_ToggleState_Set("Permission_Reservation_Edit", WorkingData?.Access.Reservation.Edit);
                Permission_ToggleState_Set("Permission_Reservation_Approve_Initial", WorkingData?.Access.Reservation.Approve.Initial);
                Permission_ToggleState_Set("Permission_Reservation_Approve_Final", WorkingData?.Access.Reservation.Approve.Final);
                Permission_ToggleState_Set("Permission_Reservation_Delegateable", WorkingData?.Access.Reservation.Delegateable);

                Permission_ToggleState_Set("Permission_Report_View", WorkingData?.Access.Report.View);
                Permission_ToggleState_Set("Permission_Report_ScheduleTimetable", WorkingData?.Access.Report.ScheduleTimetable);
                Permission_ToggleState_Set("Permission_Report_RoomUtilization", WorkingData?.Access.Report.RoomUtilization);
                Permission_ToggleState_Set("Permission_Report_MapOverview", WorkingData?.Access.Report.MapOverview);
                Permission_ToggleState_Set("Permission_Report_ReservationSlip", WorkingData?.Access.Report.ReservationSlip);
                Permission_ToggleState_Set("Permission_Report_AccountList", WorkingData?.Access.Report.AccountList);
                Permission_ToggleState_Set("Permission_Report_ActivityLog", WorkingData?.Access.Report.ActivityLog);

                Permission_ToggleState_Set("Permission_Account_Manage_Self", WorkingData?.Access.Account.Manage_Self);
                Permission_ToggleState_Set("Permission_Account_Manage_Others", WorkingData?.Access.Account.Manage_Others);

                Permission_ToggleState_Set("Permission_Templating_View", WorkingData?.Access.Templating.View);
                Permission_ToggleState_Set("Permission_Templating_Edit", WorkingData?.Access.Templating.Edit);
            }
        } catch (Error) {
            console.error(Error.message);
        }
        

    }

    const Permission_ToggleState_Get = (ID) => {
        return UI.Element_Attribute_Get(ID, "State") === "Active";
    }

    const Permission_ToggleState_Set = (ID, Data) => {
        Data === true ? UI.Element_Attribute_Set(ID, "State", "Active") : UI.Element_Attribute_Set(ID, "State", "Inactive");
    }

    const Account_Current_Approve = () => {
        if (!WorkingData) { return; }
        const Payload = _.cloneDeep(WorkingData);
        Payload.Approval = {
            ...Payload.Approval,
            State: "Approved",
            ApproverID: Account?._id,
            DateApproved: new Date()
        };
        WorkingData_Local_Update(Next => {
            Next.Approval = _.cloneDeep(Payload.Approval);
        })
        Account_Approve(WorkingData?._id);
        
        Account_Changes_CommitToDB(Payload, " approved");
        // WorkingData_Local_Update(Next => {
        //     Next.Approval.State = "Approved";
        //     Next.Approval.ApproverID = Account?._id;
        //     Next.Approval.DateApproved = new Date();
           
        // })
        // WorkingData?.Approval?.State = "Approved";
        // WorkingData?.Approval?.ApproverID = Account?._id;
        // WorkingData?.Approval?.DateApproved = new Date();
        
    }

    const Account_Current_Reject = async (ID) => {
        const Passed = await UI.Input_Evaluate([
            {
                Type: "Dropdown",
                ID: "Reason_AccountDenial",
                AC: "Pick a rejection reason"
            }]);
        if (Passed) {
            Account_Reject(ID, document.getElementById("Reason_AccountDenial").querySelector(".Dropdown_Button_Text").innerText);
        } else {
            window.Toasts_CreateToast("https://elmerf5445.github.io/Digi-Rooms-Status/Assets/Icons/favicon.png", "Error", "Enter a rejection reason.");
        }
    }
    // const Account_Reject = async () => {
    //     // WorkingData?.Approval?.State = "Rejected";
    //     // WorkingData?.Approval?.ApproverID = Account?._id;
    //     // WorkingData?.Approval?.DateApproved = new Date();
    //     const Passed = await UI.Input_Evaluate([{ Type: "Dropdown", ID: "Reason_AccountDenial", AC: "Pick a rejection reason" }])
    //     if (Passed) {
    //         console.warn(WorkingData?._id);
    //         if (!WorkingData) { return; }
    //         try {
                
    //         } catch (Error) {

    //         }
    //         /*const Payload = _.cloneDeep(WorkingData);
    //         Payload.Approval = {
    //             ...Payload.Approval,
    //             State: "Rejected",
    //             ApproverID: Account?._id,
    //             DateApproved: new Date(),
    //             Reason: document.getElementById("Reason_AccountDenial").querySelector(".Dropdown_Button_Text").innerText
    //         };
    //         WorkingData_Local_Update(Next => {
    //             Next.Approval = _.cloneDeep(Payload.Approval);
    //         })
    //         Account_Changes_CommitToDB(Payload, " rejected");*/
    //     } else {
    //         window.Toasts_CreateToast("https://bhimlex13.github.io/Student-Assistant-Portal/Assets/Icons/Logo.png", "Error", "Enter a rejection reason.");
    //     }
    // }

    const Account_Current_Deactivate = () => {
        // WorkingData?.Approval?.State = "Deactivated";
        // WorkingData?.Approval?.ApproverID = Account?._id;
        // WorkingData?.Approval?.DateApproved = new Date();
        // Account_Changes_CommitToDB(" deactivated");
        if (!WorkingData) { return; }
        const Payload = _.cloneDeep(WorkingData);
        Payload.Approval = {
            ...Payload.Approval,
            State: "Deactivated",
            ApproverID: Account?._id,
            DateApproved: new Date()
        };
        WorkingData_Local_Update(Next => {
            Next.Approval = _.cloneDeep(Payload.Approval);
        })
        Account_Changes_CommitToDB(Payload, " deactivated");
    }

    const Account_Current_Reactivate = () => {
        // WorkingData?.Approval?.State = "Approved";
        // WorkingData?.Approval?.ApproverID = Account?._id;
        // WorkingData?.Approval?.DateApproved = new Date();
        // Account_Changes_CommitToDB(" reactivated");
        if (!WorkingData) { return; }
        const Payload = _.cloneDeep(WorkingData);
        Payload.Approval = {
            ...Payload.Approval,
            State: "Approved",
            ApproverID: Account?._id,
            DateApproved: new Date()
        };
        WorkingData_Local_Update(Next => {
            Next.Approval = _.cloneDeep(Payload.Approval);
        })
        Account_Changes_CommitToDB(Payload, " reactivated");
    }

    const Account_Current_Reinstate = () => {
        // WorkingData?.Approval?.State = "Pending";
        // WorkingData?.Approval?.ApproverID = Account?._id;
        // WorkingData?.Approval?.DateApproved = new Date();
        // Account_Changes_CommitToDB(" reinstated");
        if (!WorkingData) { return; }
        const Payload = _.cloneDeep(WorkingData);
        Payload.Approval = {
            ...Payload.Approval,
            State: "Pending",
            ApproverID: Account?._id,
            DateApproved: new Date()
        };
        WorkingData_Local_Update(Next => {
            Next.Approval = _.cloneDeep(Payload.Approval);
        })
        Account_Changes_CommitToDB(Payload, " approved");
    }

    const Account_Changes_Save = () => {
        if (!WorkingData) { return; }
        if (WorkingData?.Approval?.State === "Approved") {
            const Payload = _.cloneDeep(WorkingData);
            Payload.Approval = {
                ...Payload.Approval,
                State: "Approved",
                ApproverID: Account?._id,
                DateApproved: new Date()
            };
            WorkingData_Local_Update(Next => {
                Next.Approval = _.cloneDeep(Payload.Approval);
            })
            Account_Changes_CommitToDB(Payload, " changes saved");
        }
    }



    const Account_Delete = () => {
        if (!WorkingData) { return; }
        if (WorkingData?.Approval?.State === "Rejected") {
            const Payload = _.cloneDeep(WorkingData);
            Payload.Approval = {
                ...Payload.Approval,
                State: "Deleted",
                ApproverID: Account?._id,
                DateApproved: new Date()
            };
            WorkingData_Local_Update(Next => {
                Next.Approval = _.cloneDeep(Payload.Approval);
            })
            Account_Changes_CommitToDB(Payload, " deleted");
        }
        /*WorkingData_Local_Update(Next => {
            Next.Approval.State = "Deleted";
            Next.Approval.ApproverID = Account?._id;
            Next.Approval.DateApproved = new Date();
            Account_Changes_CommitToDB(" deleted");
        })*/
        // if (WorkingData?.Approval?.State === "Rejected") {
        //     console.log("Attempting to delete account with ID: " + Accounts_Selected);
        //     WorkingData?.Approval?.State = "Deleted";
        //     Account_Changes_CommitToDB("Deleted");
        // }
        // List_Refresh();
        // window.Toasts_CreateToast("https://bhimlex13.github.io/Student-Assistant-Portal/Assets/Icons/Logo.png", "Account deleted", "Refresh this page to see the latest account list.");
    }

    const Account_Changes_CommitToDB = async (Payload, State) => {
        Attempt_Loading_Set(true);
        // Status_Saving_Set("InProgress");
        // Commit_Loading_Set(true);
        // Change_InProgress_Set(true);
        try {
            const Request_Payload = {
                Name: {
                    First: Payload.Name?.First || "",
                    MI: Payload.Name?.MI || "",
                    Last: Payload.Name?.Last || ""
                },
                Access: Payload.Access,
                Approval: Payload.Approval
            }
            await Account_Update(Payload._id, Request_Payload);
            const Account_Refreshed = await Account_Fetch_ByID(Payload._id);
            WorkingData_Set(_.cloneDeep(Account_Refreshed));
            WorkingData_Changed_Set(false);
            UI.Refresh?.();
            window.Toasts_CreateToast("https://elmerf5445.github.io/Digi-Rooms-Status/Assets/Icons/favicon.png", `Account ${State}`, "The selected account data had been updated in the database");
            Status_Saving_Set("Success");
        } catch (Error) {
            window.Toasts_CreateToast("https://elmerf5445.github.io/Digi-Rooms-Status/Assets/Icons/favicon.png", `Commit failed.`, "The selected account data couldn't be updated.");
            console.error(Error);
            Status_Saving_Set("Error");
        } finally {
            Attempt_Loading_Set(false);
        }
    }

    // const Pattern_Teacher = {
    //     InteractiveMap: {
    //         View: true,
    //         Edit: false
    //     },
    //     Schedules: {
    //         View: true
    //     },
    //     Reservation: {
    //         Create: true,
    //         Edit: false,
    //         Overwrite: false,
    //         Approve: {
    //             Initial: false,
    //             Final: false
    //         }
    //     },
    //     Report: {
    //         View: true,
    //         ScheduleTimetable: true,
    //         RoomUtilization: false,
    //         MapOverview: true,
    //         ReservationSlip: true,
    //         AccountList: false,
    //         ActivityLog: false
    //     },
    //     Account: {
    //         Manage_Self: true,
    //         Manage_Others: false
    //     },
    //     Templating: {
    //         View: false,
    //         Edit: false
    //     }
    // }

    // const Pattern_Staff = {
    //     InteractiveMap: {
    //         View: true,
    //         Edit: false
    //     },
    //     Schedules: {
    //         View: true
    //     },
    //     Reservation: {
    //         Create: true,
    //         Edit: false,
    //         Overwrite: false,
    //         Approve: {
    //             Initial: true,
    //             Final: false
    //         }
    //     },
    //     Report: {
    //         View: true,
    //         ScheduleTimetable: true,
    //         RoomUtilization: false,
    //         MapOverview: true,
    //         ReservationSlip: true,
    //         AccountList: false,
    //         ActivityLog: false
    //     },
    //     Account: {
    //         Manage_Self: true,
    //         Manage_Others: false
    //     },
    //     Templating: {
    //         View: false,
    //         Edit: false
    //     }
    // }

    // const Pattern_Administrator = {
    //     InteractiveMap: {
    //         View: true,
    //         Edit: true
    //     },
    //     Schedules: {
    //         View: true
    //     },
    //     Reservation: {
    //         Create: true,
    //         Edit: true,
    //         Overwrite: false,
    //         Approve: {
    //             Initial: true,
    //             Final: true
    //         }
    //     },
    //     Report: {
    //         View: true,
    //         ScheduleTimetable: true,
    //         RoomUtilization: true,
    //         MapOverview: true,
    //         ReservationSlip: true,
    //         AccountList: true,
    //         ActivityLog: true
    //     },
    //     Account: {
    //         Manage_Self: true,
    //         Manage_Others: true
    //     },
    //     Templating: {
    //         View: true,
    //         Edit: true
    //     }
    // }

    // const Pattern_Empty = {
    //     InteractiveMap: {
    //         View: false,
    //         Edit: false
    //     },
    //     Schedules: {
    //         View: false
    //     },
    //     Reservation: {
    //         Create: false,
    //         Edit: false,
    //         Overwrite: false,
    //         Approve: {
    //             Initial: false,
    //             Final: false
    //         }
    //     },
    //     Report: {
    //         View: false,
    //         ScheduleTimetable: false,
    //         RoomUtilization: false,
    //         MapOverview: false,
    //         ReservationSlip: false,
    //         AccountList: false,
    //         ActivityLog: false
    //     },
    //     Account: {
    //         Manage_Self: false,
    //         Manage_Others: false
    //     },
    //     Templating: {
    //         View: false,
    //         Edit: false
    //     }
    // }


    return (
        <>
            {Attempt_Loading ?
                <div className="AM_Details" Loading="true">
                    <h3 className='General_Paragraph'>
                        Attempting to save changes...
                    </h3>
                </div>
                :
                <>
                    {WorkingData ?
                        <div className="AM_Details">
                            <div className='AM_Details_Content'>
                                {WorkingData?.Approval?.State !== "Deleted" ?
                                    <>
                                        <h1 className='General_Title'>
                                            {WorkingData?.Name?.First} {WorkingData?.Name?.MI ? `${WorkingData?.Name?.MI}.` : "" } {WorkingData?.Name?.Last}
                                        </h1>

                                        {WorkingData?.Approval?.State === "Approved" ?
                                            <div>
                                                <div className='AM_Details_Status' State="Active">
                                                    Active
                                                </div>
                                                {WorkingData?.isSystemAdmin ?
                                                    <div className='AM_Details_Data'>
                                                        <h3 className='General_Paragraph'>
                                                            System admin 
                                                        </h3>
                                                        <p className='General_Paragraph'>
                                                            Permissions can't be modified
                                                        </p>
                                                    </div>
                                                    :
                                                    ""
                                                }

                                                <div className='AM_Details_Data'>
                                                    <p className='General_Paragraph'>
                                                        Date approved:
                                                    </p>
                                                    <h3 className='General_Paragraph'>
                                                        {UI.Date_Format(new Date(WorkingData?.Approval?.DateApproved)
                                                        )}
                                                    </h3>
                                                </div>
                                            </div>
                                            :
                                            <>
                                                {WorkingData?.Approval?.State === "Pending" ?
                                                    <div>
                                                        <div className='AM_Details_Status' State="Pending">
                                                            Pending approval
                                                        </div>
                                                        <div className='AM_Details_Data'>
                                                            <p className='General_Paragraph'>
                                                                Date registered:
                                                            </p>
                                                            <h3 className='General_Paragraph'>
                                                                {UI.Date_Format(new Date(WorkingData?.Approval?.DateApproved)
                                                                )}
                                                            </h3>
                                                        </div>
                                                        <div className='AM_Details_Data'>
                                                            <p className='General_Paragraph'>
                                                                Rejection reason:
                                                            </p>
                                                            <UI_Dropdown id="Reason_AccountDenial" InitialTitle="Pick a rejection reason" Items={Template_List.Reason?.Account_Denied} Fill />
                                                        </div>
                                                    </div>
                                                    :
                                                    <>
                                                        {WorkingData?.Approval?.State === "Rejected" ?
                                                            <div>
                                                                <div className='AM_Details_Status' State="Rejected">
                                                                    Rejected
                                                                </div>
                                                                <div className='AM_Details_Data'>
                                                                    <p className='General_Paragraph'>
                                                                        Date rejected:
                                                                    </p>
                                                                    <h3 className='General_Paragraph'>
                                                                        {UI.Date_Format(new Date(WorkingData?.Approval?.DateApproved)
                                                                        )}
                                                                    </h3>
                                                                </div>
                                                                <div className='AM_Details_Data'>
                                                                    <p className='General_Paragraph'>
                                                                        Reason:
                                                                    </p>
                                                                    <h3 className='General_Paragraph'>
                                                                       { WorkingData?.Approval?.Reason}
                                                                        
                                                                    </h3>
                                                                </div>
                                                            </div>
                                                            :
                                                            <>
                                                                {WorkingData?.Approval?.State === "Deactivated" ?
                                                                    <div>
                                                                        <div className='AM_Details_Status' State="Deactivated">
                                                                            Deactivated
                                                                        </div>
                                                                        <div className='AM_Details_Data'>
                                                                            <p className='General_Paragraph'>
                                                                                Date deactivated:
                                                                            </p>
                                                                            <h3 className='General_Paragraph'>
                                                                                {UI.Date_Format(new Date(WorkingData?.Approval?.DateApproved)
                                                                                )}
                                                                            </h3>
                                                                        </div>
                                                                    </div>
                                                                    :
                                                                    <div>
                                                                        <div className='AM_Details_Status' State="Unknown">
                                                                            Unknown state
                                                                        </div>
                                                                        <div className='AM_Details_Data'>
                                                                            <p className='General_Paragraph'>
                                                                                Date registered:
                                                                            </p>
                                                                            <h3 className='General_Paragraph'>
                                                                                {UI.Date_Format(new Date(WorkingData?.Approval?.DateApproved)
                                                                                )}
                                                                            </h3>
                                                                        </div>
                                                                    </div>
                                                                }
                                                            </>
                                                        }
                                                    </>
                                                }
                                            </>

                                        }
                                        <div className='AM_Details_Data'>
                                            <p className='General_Paragraph'>
                                                Email:
                                            </p>
                                            <h3 className='General_Paragraph'>
                                                {WorkingData?.Email}
                                            </h3>
                                        </div>
                                        {WorkingData?.Approval?.State === "Approved" && WorkingData?.isSystemAdmin == false ?
                                            <div className='AM_Details_PermissionList'>
                                                <h3 className='General_Paragraph'>
                                                    Permission role:
                                                </h3>
                                                <UI_Radio id="Radio_AM_PermissionList" Items={[
                                                    
                                                    {
                                                        ID: "AM_Role_Teacher",
                                                        Text: "Teacher",
                                                        onClick: { Radio_Click }
                                                    },
                                                    {
                                                        ID: "AM_Role_Staff",
                                                        Text: "OSA Staff",
                                                        onClick: { Radio_Click }
                                                    },
                                                    {
                                                        ID: "AM_Role_Staff_GSU",
                                                        Text: "GSU Staff",
                                                        onClick: { Radio_Click }
                                                    },
                                                    {
                                                        ID: "AM_Role_Administrator",
                                                        Text: "Administrator",
                                                        onClick: { Radio_Click }
                                                    },
                                                    {
                                                        ID: "AM_Role_Custom",
                                                        Text: "Custom",
                                                        onClick: { Radio_Click }
                                                    }
                                                ]}
                                                Selected={Radio_Role}
                                                onClick={Radio_Click}/>
                                                {/* <div className="Radio" id="Radio_AM_PermissionList">
                                                    <button className="Radio_Button" onClick={Radio_Click} id="AM_Role_Teacher">
                                                        <div className="Radio_Button_Indicator"></div>
                                                        <p className="Radio_Button_Text">
                                                            Teacher
                                                        </p>
                                                    </button>
                                                    <button className="Radio_Button" onClick={Radio_Click} id="AM_Role_Staff">
                                                        <div className="Radio_Button_Indicator"></div>
                                                        <p className="Radio_Button_Text">
                                                            Staff (OSA, etc.)
                                                        </p>
                                                    </button>
                                                    <button className="Radio_Button" onClick={Radio_Click} id="AM_Role_Administrator">
                                                        <div className="Radio_Button_Indicator"></div>
                                                        <p className="Radio_Button_Text">
                                                            Administrator
                                                        </p>
                                                    </button>
                                                    <button className="Radio_Button" onClick={Radio_Click} id="AM_Role_Custom">
                                                        <div className="Radio_Button_Indicator"></div>
                                                        <p className="Radio_Button_Text">
                                                            Custom
                                                        </p>
                                                    </button>
                                                </div> */}
                                                <h3 className='General_Paragraph'>
                                                    Permissions list:
                                                </h3>

                                                <p className='General_Paragraph'>
                                                    Map
                                                </p>
                                                <button className="Toggle" Style="Style_Switch" Fill_Horizontal id="Permission_InteractiveMap_View" State={WorkingData?.Access?.InteractiveMap?.View ? "Active" : "Inactive"} onClick={Toggle_Click}>
                                                    <div className="Toggle_Switch">
                                                        <div className="Toggle_Switch_Head"></div>
                                                    </div>
                                                    <p className="Toggle_Text">
                                                        Interactive Map
                                                    </p>
                                                </button>
                                                <button className="Toggle" Style="Style_Switch" Fill_Horizontal id="Permission_InteractiveMap_Edit" State={WorkingData?.Access?.InteractiveMap?.Edit ? "Active" : "Inactive"} onClick={Toggle_Click}>
                                                    <div className="Toggle_Switch">
                                                        <div className="Toggle_Switch_Head"></div>
                                                    </div>
                                                    <p className="Toggle_Text">
                                                        Map Editor
                                                    </p>
                                                </button>

                                                <p className='General_Paragraph'>
                                                    Schedules
                                                </p>
                                                <button className="Toggle" Style="Style_Switch" Fill_Horizontal id="Permission_Schedules_View" State={WorkingData?.Access?.Schedules?.View ? "Active" : "Inactive"} onClick={Toggle_Click}>
                                                    <div className="Toggle_Switch">
                                                        <div className="Toggle_Switch_Head"></div>
                                                    </div>
                                                    <p className="Toggle_Text">
                                                        View schedules
                                                    </p>
                                                </button>
                                                <button className="Toggle" Style="Style_Switch" Fill_Horizontal id="Permission_Reservation_Create" State={WorkingData?.Access?.Reservation?.Create ? "Active" : "Inactive"} onClick={Toggle_Click}>
                                                    <div className="Toggle_Switch">
                                                        <div className="Toggle_Switch_Head"></div>
                                                    </div>
                                                    <p className="Toggle_Text">
                                                        Create reservations
                                                    </p>
                                                </button>
                                                <button className="Toggle" Style="Style_Switch" Fill_Horizontal id="Permission_Reservation_Edit" State={WorkingData?.Access?.Reservation?.Edit ? "Active" : "Inactive"} onClick={Toggle_Click}>
                                                    <div className="Toggle_Switch">
                                                        <div className="Toggle_Switch_Head"></div>
                                                    </div>
                                                    <p className="Toggle_Text">
                                                        Edit reservations
                                                    </p>
                                                </button>
                                                <button className="Toggle" Style="Style_Switch" Fill_Horizontal id="Permission_Reservation_Approve_Initial" State={WorkingData?.Access?.Reservation?.Approve?.Initial ? "Active" : "Inactive"} onClick={Toggle_Click}>
                                                    <div className="Toggle_Switch">
                                                        <div className="Toggle_Switch_Head"></div>
                                                    </div>
                                                    <p className="Toggle_Text">
                                                        Approve reservation requests for the OSA
                                                    </p>
                                                </button>
                                                <button className="Toggle" Style="Style_Switch" Fill_Horizontal id="Permission_Reservation_Approve_Final" State={WorkingData?.Access.Reservation.Approve.Final ? "Active" : "Inactive"} onClick={Toggle_Click}>
                                                    <div className="Toggle_Switch">
                                                        <div className="Toggle_Switch_Head"></div>
                                                    </div>
                                                    <p className="Toggle_Text">
                                                        Approve reservation requests for the GSU
                                                    </p>
                                                </button>
                                                <button className="Toggle" Style="Style_Switch" Fill_Horizontal id="Permission_Reservation_Delegateable" State={WorkingData?.Access.Reservation.Delegateable ? "Active" : "Inactive"} onClick={Toggle_Click}>
                                                    <div className="Toggle_Switch">
                                                        <div className="Toggle_Switch_Head"></div>
                                                    </div>
                                                    <p className="Toggle_Text">
                                                        Delegateable by GSU staff
                                                    </p>
                                                </button>

                                                <p className='General_Paragraph'>
                                                    Reports
                                                </p>
                                                <button className="Toggle" Style="Style_Switch" Fill_Horizontal id="Permission_Report_View" State={WorkingData?.Access.Report.View ? "Active" : "Inactive"} onClick={Toggle_Click}>
                                                    <div className="Toggle_Switch">
                                                        <div className="Toggle_Switch_Head"></div>
                                                    </div>
                                                    <p className="Toggle_Text">
                                                        View reports
                                                    </p>
                                                </button>
                                                <button className="Toggle" Style="Style_Switch" Fill_Horizontal id="Permission_Report_ScheduleTimetable" State={WorkingData?.Access.Report.ScheduleTimetable ? "Active" : "Inactive"} onClick={Toggle_Click}>
                                                    <div className="Toggle_Switch">
                                                        <div className="Toggle_Switch_Head"></div>
                                                    </div>
                                                    <p className="Toggle_Text">
                                                        Generate schedule timetable documents
                                                    </p>
                                                </button>
                                                <button className="Toggle" Style="Style_Switch" Fill_Horizontal id="Permission_Report_RoomUtilization" State={WorkingData?.Access.Report.RoomUtilization ? "Active" : "Inactive"} onClick={Toggle_Click}>
                                                    <div className="Toggle_Switch">
                                                        <div className="Toggle_Switch_Head"></div>
                                                    </div>
                                                    <p className="Toggle_Text">
                                                        Generate room utilization documents
                                                    </p>
                                                </button>
                                                <button className="Toggle" Style="Style_Switch" Fill_Horizontal id="Permission_Report_MapOverview" State={WorkingData?.Access.Report.MapOverview ? "Active" : "Inactive"} onClick={Toggle_Click}>
                                                    <div className="Toggle_Switch">
                                                        <div className="Toggle_Switch_Head"></div>
                                                    </div>
                                                    <p className="Toggle_Text">
                                                        Generate map overview documents
                                                    </p>
                                                </button>
                                                <button className="Toggle" Style="Style_Switch" Fill_Horizontal id="Permission_Report_ReservationSlip" State={WorkingData?.Access.Report.ReservationSlip ? "Active" : "Inactive"} onClick={Toggle_Click}>
                                                    <div className="Toggle_Switch">
                                                        <div className="Toggle_Switch_Head"></div>
                                                    </div>
                                                    <p className="Toggle_Text">
                                                        Generate reservation slip documents
                                                    </p>
                                                </button>
                                                <button className="Toggle" Style="Style_Switch" Fill_Horizontal id="Permission_Report_AccountList" State={WorkingData?.Access.Report.AccountList ? "Active" : "Inactive"} onClick={Toggle_Click}>
                                                    <div className="Toggle_Switch">
                                                        <div className="Toggle_Switch_Head"></div>
                                                    </div>
                                                    <p className="Toggle_Text">
                                                        Generate account information documents
                                                    </p>
                                                </button>
                                                <button className="Toggle" Style="Style_Switch" Fill_Horizontal id="Permission_Report_ActivityLog" State={WorkingData?.Access.Report.ActivityLog ? "Active" : "Inactive"} onClick={Toggle_Click}>
                                                    <div className="Toggle_Switch">
                                                        <div className="Toggle_Switch_Head"></div>
                                                    </div>
                                                    <p className="Toggle_Text">
                                                        Generate system log documents
                                                    </p>
                                                </button>

                                                <p className='General_Paragraph'>
                                                    Accounts management
                                                </p>
                                                <button className="Toggle" Style="Style_Switch" Fill_Horizontal id="Permission_Account_Manage_Self" State={WorkingData?.Access.Account.Manage_Self ? "Active" : "Inactive"} onClick={Toggle_Click}>
                                                    <div className="Toggle_Switch">
                                                        <div className="Toggle_Switch_Head"></div>
                                                    </div>
                                                    <p className="Toggle_Text">
                                                        Change own account details
                                                    </p>
                                                </button>
                                                <button className="Toggle" Style="Style_Switch" Fill_Horizontal id="Permission_Account_Manage_Others" State={WorkingData?.Access.Account.Manage_Others ? "Active" : "Inactive"} onClick={Toggle_Click}>
                                                    <div className="Toggle_Switch">
                                                        <div className="Toggle_Switch_Head"></div>
                                                    </div>
                                                    <p className="Toggle_Text">
                                                        Manage accounts
                                                    </p>
                                                </button>

                                                <p className='General_Paragraph'>
                                                    Templating
                                                </p>
                                                <button className="Toggle" Style="Style_Switch" Fill_Horizontal id="Permission_Templating_View" State={WorkingData?.Access.Templating.View ? "Active" : "Inactive"} onClick={Toggle_Click}>
                                                    <div className="Toggle_Switch">
                                                        <div className="Toggle_Switch_Head"></div>
                                                    </div>
                                                    <p className="Toggle_Text">
                                                        View
                                                    </p>
                                                </button>
                                                <button className="Toggle" Style="Style_Switch" Fill_Horizontal id="Permission_Templating_Edit" State={WorkingData?.Access.Templating.Edit ? "Active" : "Inactive"} onClick={Toggle_Click}>
                                                    <div className="Toggle_Switch">
                                                        <div className="Toggle_Switch_Head"></div>
                                                    </div>
                                                    <p className="Toggle_Text">
                                                        Edit
                                                    </p>
                                                </button>
                                            </div>
                                            :
                                            ""
                                        }
                                    </>
                                    :
                                    <p className='General_Paragraph'>Please select an account from the list.</p>
                                }


                            </div>
                            {WorkingData?.isSystemAdmin == false ?
                                <div className='AM_Details_Controls'>
                                    {WorkingData?.Approval?.State === "Pending" ?

                                        <div>
                                            <button className='General_Button' Type="Secondary" onClick={() => Account_Current_Reject(WorkingData?._id)}>
                                                Reject request
                                            </button>
                                            <button className='General_Button' Type="Secondary" onClick={Account_Current_Approve}>
                                                Approve request
                                            </button>
                                        </div>
                                        :
                                        <>
                                            {WorkingData?.Approval?.State === "Approved" ?
                                                <div>
                                                    <button className='General_Button' Type="Secondary" onClick={() => Account_Deactivate(WorkingData?._id)}>
                                                        Deactivate this account
                                                    </button>
                                                    <button className='General_Button' Type="Secondary" onClick={Account_Changes_Save}>
                                                        Save changes
                                                    </button>
                                                </div>
                                                :
                                                <>
                                                    {WorkingData?.Approval?.State === "Rejected" ?
                                                        <div>
                                                            <button className='General_Button' Type="Secondary" onClick={Account_Delete}>
                                                                Delete this account
                                                            </button>
                                                            <button className='General_Button' Type="Secondary" onClick={() => Account_Reinstate(WorkingData?._id)}>
                                                                Reinstate to pending approval
                                                            </button>
                                                        </div>
                                                        :
                                                        <>
                                                            {WorkingData?.Approval?.State === "Deactivated" ?
                                                                <div>
                                                                    <button className='General_Button' Type="Secondary" onClick={() => Account_Reactivate(WorkingData?._id)}>
                                                                        Reactivate this account
                                                                    </button>
                                                                </div>
                                                                :
                                                                ""
                                                            }
                                                        </>
                                                    }
                                                </>
                                            }
                                        </>


                                    }

                                </div>
                                :
                                ""
                            }

                        </div>
                        :
                        <p>Loading.</p>}
                </>
            }

        </>
    );
}

